import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  constructor() {
    this.applyDarkTheme();
  }

  /** O app usa apenas tema escuro. */
  isDarkMode(): boolean {
    return true;
  }

  private applyDarkTheme(): void {
    const apply = () => {
      const body = document.body;
      const html = document.documentElement;
      const ionApp = document.querySelector('ion-app');

      for (const el of [body, html, ionApp].filter(Boolean) as HTMLElement[]) {
        el.classList.remove('light');
        el.classList.add('dark', 'ion-palette-dark');
        el.setAttribute('data-theme', 'dark');
      }

      html.style.colorScheme = 'dark';
    };

    apply();
    setTimeout(apply, 10);
  }
}
